<div class="container-fluid">
  <app-header titleText="Quotes By Lead Source" i18n-titleText>
    <div button class="float-right">
      <div *ngIf="!isRequesting">
        <button type="button" class="btn btn-bidit-navigate mr-1" (click)="showParameters()" i18n>Update Filters</button>
        <button *ngIf="report" type="button" class="btn btn-bidit-navigate" (click)="renderReport()" i18n>Export</button>
      </div>
      <app-spinner [isRunning]="isRequesting"></app-spinner>
    </div>
  </app-header>

  <div *ngIf="report == null">
    <h5 i18n>Please provide report criteria</h5>
  </div>
  <div *ngIf="report">
    <div class="row header-text">

      <div class="col-md-4">
        <app-dealer-logo></app-dealer-logo>
      </div>
      <div class="col-md-6 filter-zone">
        <p>
          <span i18n>REPORT DEFINED:</span><br />
          <span i18n>Date Range:</span> {{parameters.startDate | date: 'M/d/yyyy'}} - {{parameters.endDate | date: 'M/d/yyyy'}}<br />
          <ng-template [ngIf]="salesperson"><span i18n>Salesperson:</span> {{salesperson.firstName}} {{salesperson.lastName}}<br /></ng-template>
          <ng-template [ngIf]="selectedLeadSources"><span i18n>Lead Sources:</span> {{selectedLeadSources}}<br /></ng-template>
        </p>
      </div>

    </div>

    <div class="content">
      <div class="quote-month-summary">
        <h2 i18n>QUOTES</h2>
        <div>
          <table class="table table-bidit">
            <thead>
              <tr>
                <th i18n>Quote Name</th>
                <th i18n>Customer</th>
                <th i18n>Lead Comments</th>
                <th i18n>Quote Status</th>
                <th i18n>Date Quote Created</th>
                <th i18n>Salesperson</th>
                <th i18n>Quote Amount</th>
                <th *ngIf="parameters.grossMargin && showMargins" i18n>Gross Margin $</th>
                <th *ngIf="parameters.grossMargin && showMargins" i18n>Gross Margin %</th>
                <th i18n>View</th>
              </tr>
            </thead>
            <tbody>
              <ng-template ngFor let-groupData [ngForOf]="report.groupData">
                <tr>
                  <td colspan="10">
                    <span i18n>Lead Source:</span> {{groupData.leadSource}}
                  </td>
                </tr>
                <tr *ngFor="let quote of groupData.quoteDetails">
                  <td>{{quote.quote_Name}}</td>
                  <td>
                    <ng-template [ngIf]="quote.customer">
                      {{quote.customer.customer_BusinessName}}
                    </ng-template>
                  </td>
                  <td>{{quote.quote_LeadSourceComments}}</td>
                  <td>{{quote.quoteStatus}}</td>
                  <td>{{quote.quote_Created | date: 'M/d/yyyy'}}</td>
                  <td>
                    <div>
                      <div *ngFor="let assignment of quote.quoteAssignments">
                        {{assignment.assignedTo.firstName}} {{assignment.assignedTo.lastName}}
                      </div>
                    </div>
                  </td>
                  <td>
                    <ng-template [ngIf]="quote.quote_BidAmount">
                      ${{quote.quote_BidAmount | number: '1.2-2'}}
                    </ng-template>
                  </td>
                  <td *ngIf="parameters.grossMargin && showMargins">
                    <ng-template [ngIf]="quote.quote_GrossMargin">
                      ${{quote.quote_BidAmount - quote.totalCost | number: '1.2-2'}}
                    </ng-template>
                  </td>
                  <td *ngIf="parameters.grossMargin && showMargins">
                    <ng-template [ngIf]="quote.quote_GrossMargin">
                      {{quote.quote_GrossMargin | number: '1.2-4' }} %
                    </ng-template>
                  </td>
                  <td>
                    <a routerLink="/quote/{{quote.quote_ID}}" class="btn btn-bidit-submit" i18n>View</a>
                  </td>
                </tr>
                <tr class="source-summary-row">
                  <td colspan="2">
                    {{groupData.leadSource}} <span i18n>Totals</span>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    ${{groupData.bidAmount | number: '1.2-2'}}
                  </td>
                  <td *ngIf="parameters.grossMargin && showMargins">
                    ${{groupData.bidAmount - groupData.totalCost | number: '1.2-2'}}
                  </td>
                  <td *ngIf="parameters.grossMargin && showMargins">
                    {{groupData.quoteMargin * 100 | number: '1.2-2' }} %
                  </td>
                  <td>
                  </td>
                </tr>
              </ng-template>              
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
